import { memo } from 'react';
import cn from 'classnames';

import ConditionalWrapper from './ConditionalWrapper.jsx';

const NavigationButton = memo(function NavigationButton({
  btnAriaLabel,
  btnTextCondensed,
  btnTextExpanded,
  btnType,
  currentPage,
  isDisabled,
  onPrevClick,
  onNextClick,
  totalPages,
  useButtons,
}) {
  const isBtnDisabled = ((currentPage <= 1) && (btnType === 'prev')) || ((currentPage >= totalPages) && (btnType === 'next'));

  const onBtnClick = (e) => {
    if (btnType === 'prev') {
      onPrevClick(e, btnTextCondensed);
    } else {
      onNextClick(e, btnTextCondensed);
    }
  };

  return (
    <li
      className={isBtnDisabled || isDisabled ? 'disabled' : ''}
    >
      <ConditionalWrapper
        useButtons={useButtons}
        buttonWrapper={
          (children) => <button
            aria-label={btnAriaLabel}
            className={cn(
              'lds-link',
              btnType,
              {
                disabled: isBtnDisabled,
              }
            )}
            disabled={isBtnDisabled || isDisabled}
            onClick={(e) => onBtnClick(e)}
          >
            {children}
          </button>
        }
        linkWrapper={
          (children) => <a
            aria-disabled={isBtnDisabled}
            aria-label={btnAriaLabel}
            className={cn(
              'lds-link',
              btnType,
              {
                disabled: isBtnDisabled,
              }
            )}
            href={isBtnDisabled ? null : '#'}
            onClick={(e) => onBtnClick(e)}
            role={isBtnDisabled ? 'link' : null}
          >
            {children}
          </a>
        }
      >
        {
          btnType === 'prev' && <lds-icon name="CaretLeft" decorative></lds-icon>
        }
        <span>
          <span className="expanded">{btnTextExpanded}</span>
          <span className="condensed">{btnTextCondensed}</span>
        </span>
        {
          btnType === 'next' && <lds-icon name="CaretRight" decorative></lds-icon>
        }
      </ConditionalWrapper>
    </li>
  );
});

export default NavigationButton;
